import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { RoleEnum } from '../enums/role.enum';

/**
 * De pagina met club albums (/club-albums) alleen nog in een league-omgeving
 * (League › Clubs, docs/QFA-LEAGUE-OMGEVING.md) en voor een super-admin
 * (eigenaar 03-11-2026: "we willen geen club albums meer"). Een gewone club
 * kiest een tegenstander via het zoeken; de eigen club maakt het platform
 * zelf aan. Kan de omgeving niet opgehaald worden, dan gaat de pagina open:
 * liever dat dan iemand buitensluiten.
 */
export const clubAlbumsGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const rol = typeof auth.user?.role === 'string' ? auth.user.role : auth.user?.role?.key;
  if (rol === RoleEnum.SUPER_ADMIN || !!auth.user?.home_club) return true;
  return auth.omgevingen().pipe(
    map((lijst) => (lijst ?? []).some((o) => o.active && o.kind === 'league') || router.createUrlTree(['/matches'])),
    catchError(() => of(true)),
  );
};
